var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultIcon = function SvgDefaultIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M22.67 24.003V16a2.668 2.668 0 0 0-2.668-2.668H6.662A2.667 2.667 0 0 0 3.996 16v8.003a2.667 2.667 0 0 0 2.668 2.668h13.339a2.668 2.668 0 0 0 2.668-2.668Z",
    stroke: "#A2A9B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.995 18.773H22.67M8.263 13.332l1.614-6.029a2.663 2.663 0 0 1 3.268-1.88l12.886 3.454a2.663 2.663 0 0 1 1.88 3.268l-2.067 7.723a2.657 2.657 0 0 1-3.175 1.908",
    stroke: "#A2A9B0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDefaultIcon;